var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetaBaixa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7485 12.3881C10.836 12.3881 10.907 12.4591 10.907 12.5466C10.907 12.6341 10.836 12.7051 10.7485 12.7051L1.15375 12.7051C1.06622 12.7051 0.995274 12.6341 0.995274 12.5466L0.995274 2.83658C0.995274 2.74906 1.06622 2.67811 1.15375 2.67811C1.24127 2.67811 1.31222 2.74906 1.31222 2.83658L1.31222 12.164L12.1347 1.34149C12.1966 1.27961 12.297 1.27961 12.3589 1.34149C12.4207 1.40338 12.4207 1.50372 12.3589 1.56561L1.53633 12.3881L10.7485 12.3881Z",
    fill: "#F9473E",
    stroke: "#F9473E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaBaixa);
export default __webpack_public_path__ + "static/media/setaBaixa.671ec6ba0d0962b3b9f0f8192bf96ace.svg";
export { ForwardRef as ReactComponent };